import React from "react"
import PageContainer from "src/components/page/PageContainer"
import DataSourcesTable from "./DataSourcesTable"

const DataSourcesPage: React.FC = () => {
  return (
    <PageContainer>
      <DataSourcesTable />
    </PageContainer>
  )
}

export default DataSourcesPage
